<script lang="ts">
	import { page } from '$app/stores';
	import { getHubStores } from '$lib/stores/hubStores';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import BreakPoint from '$lib/components/BreakPoint/BreakPoint.svelte';
	import CollectionsMenuItem from './CollectionMenu/CollectionsMenuItem.svelte';
	import SearchInput from './Search/SearchInput.svelte';
	import CollectionsMenu from './CollectionMenu/CollectionsMenu.svelte';
	import { isSideBarOpen, selectedCollection, selectedTag } from './stores';
	import { onMount } from 'svelte';
	import { _ } from 'svelte-i18n';

	export let searchValue: string | null = null;

	const { hub, collections } = getHubStores();
	let searchMode = false;

	$: {
		if (!$page.route.id?.includes('/posts')) {
			$selectedCollection = $collections.find(
				(collection) => $page.data.postsFilters?.collectionSlug == collection.slug
			);
		}
	}

	$: $selectedTag = $page.data.postsFilters?.tag;

	onMount(() => {
		if (searchValue) {
			searchMode = true;
		}
	});

	const enableSearchMode = () => {
		if (!searchMode) {
			searchMode = true;
			if (!$hub?.theme?.coverHideCover && $page.url.pathname == '/') {
				scroll({ top: 430 }); //TODO: This value should be calculated from the cover height
			}
		}
	};
</script>

<div class="root">
	<BreakPoint>
		<div class="content">
			<button
				type="button"
				class="searchButton"
				aria-label={$_('common.search')}
				on:click={enableSearchMode}>
				<Icon icon="search" className="search navIcon" size="20" clickable />
			</button>
			{#if searchMode}
				<SearchInput hubName={$hub.name} bind:value={searchValue} />
			{:else}
				<div class="desktop">
					<CollectionsMenu />
				</div>
				<button type="button" class="mobile" on:click={() => ($isSideBarOpen = true)}>
					<CollectionsMenuItem collection={$selectedCollection} />
					<Icon icon="dropdown-arrow" className="navIcon" size="24" />
				</button>
			{/if}
			{#if searchMode}
				<button
					type="button"
					class="searchCloseButton"
					aria-label={$_('hubs.post.accessibility.search.mode.exit')}
					on:click={() => (searchMode = false)}>
					<Icon icon="close" className="navIcon" size="20" clickable />
				</button>
			{/if}
		</div>
	</BreakPoint>
</div>

<style>
	.root {
		position: sticky;
		z-index: var(--z-index-Hub-collections);
		background-color: var(--collectionsBackgroundColor);
		box-shadow: rgb(0 0 0 / 10%) 0 1px 3px;
		inset-block-start: var(--navbarHeight);
	}

	.root :global(*) {
		color: var(--collectionsFontColor) !important;
		font-family: var(--presslyFontFamily);
	}

	.content {
		display: flex;
		align-items: center;
		block-size: 40px;
		inline-size: 100%;
	}

	.desktop {
		inline-size: 100%;
	}

	.mobile {
		display: none;
	}

	.searchButton,
	.searchCloseButton {
		all: unset;
		margin-inline-start: 5px;
		border-block-end: 4px solid transparent;
	}

	.searchButton:focus,
	.searchCloseButton:focus {
		outline: -webkit-focus-ring-color auto 1px;
	}

	@media screen and (max-width: 575px) {
		.desktop {
			display: none;
		}

		.mobile {
			all: unset;
			display: flex;
			align-items: center;
			cursor: pointer;
		}
	}
</style>
